// Icon + label lookups shared by the campaign edit form's rich pickers
// (editFieldControls.tsx) and the read-only details cards, so a field renders
// identically on both tabs. Kept out of editFieldControls so the read view can
// label a goal without importing the pickers.

import {
  RocketLaunch,
  Megaphone,
  Target,
  CreditCard,
  ChatCircleDots,
  type Icon,
} from '../../design-system/icons';
import { PRIMARY_GOAL_OPTIONS } from './editFieldOptions';

const PRIMARY_GOAL_ICONS: Record<string, Icon> = {
  brand_awareness: RocketLaunch,
  product_launch: Megaphone,
  lead_generation: Target,
  sales: CreditCard,
  engagement: ChatCircleDots,
};

/** Icon + display label for a stored primary_goal value. Label comes from the
 *  option list, not titleCase — `sales` reads "Drive Sales", not "Sales". */
export function primaryGoalMeta(value: string): { Icon: Icon; label: string } {
  return {
    Icon: PRIMARY_GOAL_ICONS[value] ?? Target,
    label: PRIMARY_GOAL_OPTIONS.find((o) => o.value === value)?.label ?? '',
  };
}
